import { render } from "./SelectableCard.vue?vue&type=template&id=00b5f866&scoped=true"
import script from "./SelectableCard.vue?vue&type=script&lang=js"
export * from "./SelectableCard.vue?vue&type=script&lang=js"

import "./SelectableCard.vue?vue&type=style&index=0&id=00b5f866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b5f866"]])

export default __exports__